import { Container, Grid } from '@mui/material'
import Prize from './Prize';
import Combos from './combos/Combos';

const System = () => {

    return (
        <Container sx={{ paddingTop: '1rem' }}>
            <Grid container spacing={2}>
                {/* PRIZE TABLE */}
                <Grid item xs={12}>
                    <Prize />
                </Grid>
                <Grid item xs={12}>
                    <Combos />
                </Grid>
            </Grid>
        </Container>
    )
}

export default System